import firebase from 'firebase';

var firebaseConfig = {
    apiKey: "AIzaSyCw-T31L9EGjvF_3wI_wBXVrbnkOBZ8Lfg",
    authDomain: "portfolioapp-f9a6f.firebaseapp.com",
    projectId: "portfolioapp-f9a6f",
    storageBucket: "portfolioapp-f9a6f.appspot.com",
    messagingSenderId: "593340908686",
    appId: "1:593340908686:web:7a403c08861e67d2fdb5df",
    measurementId: "G-T1BW37M79G"
};
	
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
var db = firebase.firestore();

export default db;
